import type { Unlock } from "@iyk/music-domain/client"
import * as React from "react"
import { AppRoutes, withBaseUrl } from "../../../AppRoutes.ts"

type UnlocksAnalytics = {
  trackView: (unlockId: Unlock.Id) => void
}

const UnlocksAnalyticsContext = React.createContext<UnlocksAnalytics | null>(null)

export const UnlocksAnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const tracked = React.useRef<Set<Unlock.Id>>(new Set())

  const value = React.useMemo(() => {
    return {
      trackView: (unlockId: Unlock.Id) => {
        if (tracked.current.has(unlockId)) return

        tracked.current.add(unlockId)

        void fetch(withBaseUrl(AppRoutes.api.unlocks.view), {
          method: "POST",
          body: JSON.stringify({ unlockId })
        }).catch(() => {})
      }
    }
  }, [])

  return <UnlocksAnalyticsContext.Provider value={value}>{children}</UnlocksAnalyticsContext.Provider>
}

export const useUnlocksAnalytics = (): UnlocksAnalytics => {
  const unlocksAnalytics = React.useContext(UnlocksAnalyticsContext)

  if (!unlocksAnalytics) {
    throw new Error("useUnlocksAnalytics must be used within an UnlocksAnalyticsProvider")
  }

  return unlocksAnalytics
}
